import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "loft-taxi-mui-theme";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { compose } from "redux";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core";
import { handleUnauthorize } from "../redux/modules/auth/actions";
import { withRouter } from "react-router-dom";

const styles = () => ({
  appBar: {
    backgroundColor: "#ffffff"
  },
  grow: {
    flexGrow: 1
  }
});

export const AppHeader = compose(
  withRouter,
  connect(
    state => ({ loggedIn: state.auth.isLoggedIn }),
    { unauthorize: handleUnauthorize }
  ),
  withStyles(styles)
)(({ loggedIn, unauthorize, classes }) => (
  <AppBar className={classes.appBar} position="static">
    <Toolbar>
      <Typography className={classes.grow}>
        <Logo />
      </Typography>
      <Button component={Link} to="/map">
        Карта
      </Button>
      <Button component={Link} to="/profile">
        Профиль
      </Button>
      {loggedIn ? (
        <Button onClick={unauthorize}>Выйти</Button>
      ) : (
        <Button component={Link} to="/login">
          Войти
        </Button>
      )}
    </Toolbar>
  </AppBar>
));
